export default __webpack_public_path__ + "static/media/011-rainbow.af5bfc5c.svg";